var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} /* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/explicit-module-boundary-types */
import PropTypes from "prop-types";
import { css } from "styled-components";
import { map } from "../../breakpoint";
export var width = function width(props) {
  return css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref) {
    var width = _ref.width;
    return map(width, function (val) {
      return val !== undefined && css(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n          width: ", ";\n        "])), val);
    });
  });
};
export var minWidth = function minWidth(props) {
  return css(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref2) {
    var minWidth = _ref2.minWidth;
    return map(minWidth, function (val) {
      return val !== undefined && css(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n          min-width: ", ";\n        "])), val);
    });
  });
};
export var maxWidth = function maxWidth(props) {
  return css(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref3) {
    var maxWidth = _ref3.maxWidth;
    return map(maxWidth, function (val) {
      return val !== undefined && css(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n          max-width: ", ";\n        "])), val);
    });
  });
};
export var height = function height(props) {
  return css(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref4) {
    var height = _ref4.height;
    return map(height, function (val) {
      return val !== undefined && css(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n          height: ", ";\n        "])), val);
    });
  });
};
export var minHeight = function minHeight(props) {
  return css(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref5) {
    var minHeight = _ref5.minHeight;
    return map(minHeight, function (val) {
      return val !== undefined && css(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n          min-height: ", ";\n        "])), val);
    });
  });
};
export var maxHeight = function maxHeight(props) {
  return css(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  ", ";\n"])), function (_ref6) {
    var maxHeight = _ref6.maxHeight;
    return map(maxHeight, function (val) {
      return val !== undefined && css(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n          max-height: ", ";\n        "])), val);
    });
  });
};
export var dimensionPropType = PropTypes.string;
export var dimensionPropTypeMap = PropTypes.oneOfType([dimensionPropType, PropTypes.shape({
  xs: dimensionPropType,
  sm: dimensionPropType,
  md: dimensionPropType,
  lg: dimensionPropType,
  xl: dimensionPropType,
  xxl: dimensionPropType,
  xxxl: dimensionPropType
})]);